import { Modal, Box } from '@mui/material';
import { ReactComponent as Close } from '../assets/icon/Close.svg';
import DropDownComponent, { TextFieldComponent } from './inputField';
import PlainButton, { UnileverButton } from './ButtonComponents';
import { useAzureData } from '../context/AzureContext';
import { clonePromptAPI } from '../service/apiServices';
import { useEffect, useState } from 'react';
import { usePromptLibraryContext } from '../context/PromptLibraryContext';
import { usePromptContext } from '../context/PromptContextType';

export default function ModalView({
  open = false,
  handleClose,
  id = '',
  promptName = '',
  totalVersions,
  setAllPromptStatus = () => {}
}: {
  open: boolean;
  handleClose: () => void;
  id?: string;
  promptName?: string;
  totalVersions?: number;
  setAllPromptStatus?: () => void;
}) {
  const { apiToken } = useAzureData();
  const [copyData, setCopyData] = useState({ promptID: '', versionID: '', promptNameField: '' });
  const { getPromptlibraryData } = usePromptLibraryContext();
  const [isLoading, setLoading] = useState(false);
  const [promptNameField, setPromptNameField] = useState('');

  useEffect(() => {
    setPromptNameField('');
  }, [promptName]);
  const [nameError, setNameError] = useState(false);
  const { promptNameCheckFunction } = usePromptContext();

  const handleCopyButton = async () => {
    // setLoading(true);
    if (promptName) {
      const temp = await promptNameCheckFunction(promptNameField);
      if (temp?.exists) {
        setNameError(true);
        return;
      } else {
        setNameError(false);
      }
    }
    try {
      await clonePromptAPI(copyData, promptNameField, apiToken)?.then(() => {
        getPromptlibraryData();
      });
    } catch (error) {
      console.error('Error while adding prompt:', error);
      alert(error);
    } finally {
      handleClose();
      setLoading(false);
      setAllPromptStatus();
    }
  };
  const availableVersions = [...Array(totalVersions)].map((_, i) => ({
    title: String(i + 1),
    id: i + 1
  }));

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="alignDataCenter">
      <Box
        style={{
          backgroundColor: 'rgba(255, 255, 255, 1)',
          border: 'none',
          width: '580px',
          height: '350px',
          margin: 'auto',
          borderRadius: '8px',
          padding: 20
        }}>
        <Box className="d-flex justify-content-between align-items-start">
          <div>
            <div className="h6 w600 un_standard_color" style={{ margin: '10px 0' }}>
              Copy to My Prompts
            </div>
            <p className="h5_400" style={{ fontWeight: 400, color: 'var(--grey_tone)' }}>
              {/* Copy this prompt to my prompts with selected versions. */}
              Choose from the available versions from the DropDown.
            </p>
          </div>{' '}
          <Close style={{ cursor: 'pointer' }} onClick={handleClose} />
        </Box>
        <TextFieldComponent
          header={'Prompt Name'}
          isMandatory={true}
          value={promptNameField}
          handleSelection={(a, b) => {
            setPromptNameField(b);
          }}
          error={nameError}
        />
        <DropDownComponent
          fieldName={'Select Version'}
          isMandatory={true}
          options={availableVersions}
          value={copyData?.versionID}
          handleSelection={(name, versionid = '') =>
            setCopyData({ promptID: id, versionID: versionid })
          }
        />
        <Box className="d-flex justify-content-end">
          <PlainButton
            buttonAction={handleClose}
            styleClass={{
              color: 'var(--uni_std_clr)',
              borderShadow: 'rgba(0, 0, 0, 0.05)',
              marginRight: '10px'
            }}>
            Cancel
          </PlainButton>
          <UnileverButton
            disabled={!copyData?.versionID || !promptNameField || isLoading}
            buttonAction={handleCopyButton}>
            {isLoading ? 'Loading' : 'Copy'}
          </UnileverButton>
        </Box>
      </Box>
    </Modal>
  );
}
